import { EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var ChartDateIntervalSelectorComponent = /** @class */ (function () {
    function ChartDateIntervalSelectorComponent(fuseTranslationLoaderService) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.activeButtonEvent = new EventEmitter();
        this.buttonState = {
            activeButton: 'WEEK',
            disabledButtons: {
                DAY: false,
                WEEK: true,
                MONTH: true
            }
        };
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    ChartDateIntervalSelectorComponent.prototype.ngOnChanges = function (changes) {
        if (!changes || !changes.dates || !changes.dates.currentValue || !changes.dates.currentValue.from || !changes.dates.currentValue.to) {
            return;
        }
        if (changes.dates.currentValue === changes.dates.previousValue) {
            return;
        }
        this.setAvailableDateInterval();
        this.activeButtonChange(this.buttonState.activeButton, changes.dates.firstChange);
    };
    ChartDateIntervalSelectorComponent.prototype.activeButtonChange = function (dateInterval, isFirstChange) {
        if (this.buttonState.activeButton === dateInterval && !isFirstChange) {
            return;
        }
        this.buttonState.activeButton = dateInterval;
        this.activeButtonEvent.emit(dateInterval);
    };
    ChartDateIntervalSelectorComponent.prototype.setAvailableDateInterval = function () {
        this.setDisabledButtons();
        this.enableFirstAvailableButton();
    };
    ChartDateIntervalSelectorComponent.prototype.setDisabledButtons = function () {
        var _a = this.dates, from = _a.from, to = _a.to;
        var daysInterval = to.diff(from, 'days');
        var mountInterval = to.diff(from, 'months');
        this.buttonState.disabledButtons = {
            DAY: true,
            WEEK: true,
            MONTH: true
        };
        if (daysInterval <= 20) {
            this.buttonState.disabledButtons.DAY = false;
        }
        if (mountInterval <= 3) {
            this.buttonState.disabledButtons.WEEK = false;
        }
        if (mountInterval > 1) {
            this.buttonState.disabledButtons.MONTH = false;
        }
    };
    ChartDateIntervalSelectorComponent.prototype.enableFirstAvailableButton = function () {
        for (var key in this.buttonState.disabledButtons) {
            if (this.buttonState.disabledButtons.hasOwnProperty(key) && !this.buttonState.disabledButtons[key]) {
                this.activeButtonChange(key);
                break;
            }
        }
    };
    return ChartDateIntervalSelectorComponent;
}());
export { ChartDateIntervalSelectorComponent };
